import MixedGridMediaItem from '@phoenix/mixins/components/mixedGrid/MixedGridMediaItem';

export default {
  mixins: [MixedGridMediaItem],

  props: {
    cta: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    hasCta() {
      return Object.hasOwn(this.cta, 'target');
    },
    hasTitle() {
      return this.title !== '';
    },
  },
};
